import React from "react";
import { Box, Heading, Stack, Text, useTheme } from "@origin-digital/ods-core";
import { SparkleIcon } from "./SparkleIcon";
import { content } from "./AIAnswer.content";
import { AIAnswerCard } from "./AIAnswer.styles";
import { AIAnswerSkeleton } from "./AIAnswerSkeleton";
import { AIAnswerMarkdown } from "./AIAnswerMarkdown";

export interface AIAnswerProps {
  answer: string;
  status?: "idle" | "connecting" | "streaming" | "done" | "error";
  error?: string | null;
}

const AIAnswerHeading: React.FC = () => {
  const theme = useTheme();
  const brandOrange = theme.palette.primary.main;

  return (
    <Box display="flex" alignItems="center" gap="xsmall">
      <SparkleIcon strokeColor={brandOrange} fillColor={brandOrange} />
      <Stack space="none">
        <Heading variant="h4">{content.title}</Heading>
      </Stack>
    </Box>
  );
};

export const AIAnswer: React.FC<AIAnswerProps> = ({
  answer,
  status,
  error,
}) => {
  if (status === "error") {
    return (
      <AIAnswerCard data-id="ai-answer-error">
        <Text tone="critical" variant="body">
          {error ?? "Something went wrong. Please try again."}
        </Text>
      </AIAnswerCard>
    );
  }

  const isLoading =
    status === "connecting" || (status === "streaming" && !answer);

  return (
    <Box
      marginBottom="xlarge"
      data-id={isLoading ? "ai-answer-skeleton" : "ai-answer"}
    >
      <Stack space="large">
        <AIAnswerHeading />
        {isLoading ? (
          <AIAnswerSkeleton />
        ) : (
          <AIAnswerMarkdown>{answer}</AIAnswerMarkdown>
        )}
      </Stack>
    </Box>
  );
};
